import { RodRequestCaddy, CrewMember } from '@bechtel/types';

export interface EditCaddyProps {
  caddy: RodRequestCaddy;
  onClose: () => void;
  onUpdateCaddy: (caddy: RodRequestCaddy) => void;
  welders: CrewMember[];
  loading?: boolean;
}
